import React from 'react';
import { styled } from '@compiled/react';
import InvalidIcon from '@atlaskit/icon/core/error';
import InvalidIconOld from '@atlaskit/icon/glyph/jira/failed-build-status';
import { token } from '@atlaskit/tokens';
import type { CascadingSelectOption } from '../../common/types.tsx';

export const formatOptionLabel = ({ label, isInvalid, invalidMessage }: CascadingSelectOption) => {
	if (isInvalid) {
		return (
			<InvalidOption>
				<InvalidOptionText>{label}</InvalidOptionText>
				<InvalidOptionIconWrapper>
					<InvalidIcon
						color={token('color.icon.danger')}
						label={invalidMessage ?? ''}
						LEGACY_fallbackIcon={InvalidIconOld}
					/>
				</InvalidOptionIconWrapper>
			</InvalidOption>
		);
	}

	return label;
};

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const InvalidOption = styled.div({
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
	color: token('color.text.danger'),
	display: 'flex',
	flexDirection: 'row',
	alignItems: 'center',
	justifyContent: 'space-between',
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const InvalidOptionText = styled.span({
	flexShrink: 1,
	overflow: 'hidden',
	textOverflow: 'ellipsis',
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const InvalidOptionIconWrapper = styled.span({
	flexShrink: 0,
});
